module.exports = __webpack_public_path__ + "static/media/close-filters.bb93e3a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/close-filters.svg
// module id = 81
// module chunks = 0